import ProductItem from "./ProductItem";
import { useEffect, useState } from "react";
import ProductForm from "./ProductForm";

export default function ProductList({ products, onChange }) {
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);

  const [filterData, setFilterData] = useState([]);
  useEffect(() => {
    const resultado = products
      .filter(item => {
        const valores = Object.values(item); // obtener todos los valores del documento
        return valores.some(valor =>
          typeof valor === 'string' &&
          valor.toLowerCase().includes(search.toLowerCase())
        );
      })
    // .sort((a, b) => a.data().empresa.localeCompare(b.data().empresa));

    setFilterData(resultado);
  }, [search, products]);
  return (
    <>
      <div>
        <div className="mb-4 grid items-end gap-3 md:grid-cols-2">
          <label className="block text-left text-sm font-medium"><span className="mb-2 block">Filtrar</span><input className="form-control" type="text" placeholder="Buscar producto"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)} />
          </label>
          <button className="btn btn-info w-full" onClick={() => setModal(true)}>Agregar producto</button>
        </div>
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {filterData.map((p) => (
            <div key={p.id}>
              <ProductItem product={p} products={products} onChange={onChange} />
            </div>
          ))}
        </div>
      </div>

      <ProductForm onSuccess={onChange} products={products} show={modal} setShow={setModal} isEdit={false} />
    </>
  );
}
